<template>
  <div class="settled_school">
    <div class="banner">
      <img src="@/assets/img/settled_school/banner.png" alt="">
    </div>
    <!-- 高校列表 -->
    <div class="school">
      <div class="m">
        <div class="top">
          <h3>已入驻高校</h3>
          <ul>
            <li>
              <span>20</span>
              座一二线城市
            </li>
            <li>
              <span>8</span>
               大国内美院
            </li>
            <li>
              <span>95</span>
              所一流设计院校
            </li>
          </ul>
        </div>
        <ul class="school_list">
          <li v-for="item in list">
            <div class="item" v-for="it in item">{{it}}</div>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="page_box m">
        <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
      </div>
    </div>
    <!-- 联系方式 -->
    <div class="contact">
      <div class="m">
        <h3>高校入驻联系方式</h3>
        <ul class="contact_list">
          <li>
            <i class="icon icon-phone"></i>
            <span>陈女士：18024187142</span>
          </li>
          <li>
            <i class="icon icon-phone"></i>
            <span>吕先生：18024127513</span>
          </li>
          <li>
            <i class="icon icon-email"></i>
            <span>service@91ant.com</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 平台功能简介 -->
    <div class="synopsis">
      <div class="m">
        <h3>平台功能简介</h3>
        <ul>
          <li>
            <i class="icon icon1"></i>
            <div>
              <h4>多级认证管理</h4>
              <span>展览作品风控管理</span>
            </div>
          </li>
          <li>
            <i class="icon icon2"></i>
            <div>
              <h4>毕设展云展示</h4>
              <span>毕设作品数字档案库</span>
            </div>
          </li>
          <li>
            <i class="icon icon3"></i>
            <div>
              <h4>院校名师风采</h4>
              <span>院校形象及招生名片</span>
            </div>
          </li>
          <li>
            <i class="icon icon4"></i>
            <div>
              <h4>作品专属二维码</h4>
              <span>快捷分享提升影响力</span>
            </div>
          </li>
          <li>
            <i class="icon icon5"></i>
            <div>
              <h4>创作过程记录</h4>
              <span>生动活泼的作品创作</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import myPage from "@/components/myPage/myPage";
  export default {
    components:{
      myPage
    },
    data(){
      return{
        list:[
          ['中央美术学院','江西师范大学','上海工艺美术职业学院','常州纺织服装职业技术学院'],
          ['清华大学美术学院','华侨大学','顺德职业技术学院','河南轻工职业学院'],
          ['同济大学','五邑大学','山东艺术设计职业学院','黑龙江三江美术职业学院'],
          ['广州美术学院','江西服装学院','广州番禺职业技术学院','无锡工艺职业技术学院'],
          ['湖北美术学院','广东海洋大学','天津工艺美术职业学院','广东工程职业技术学院'],
          ['四川美术学院','广东技术师范大学','广东职业技术学院','广东科学技术职业学院'],
          ['西安美术学院','上海师范大学天华学院','中山职业技术学院','威海职业学院'],
          ['中国美术学院上海设计学院','南通大学','广东岭南职业技术学院','云南轻纺职业学院'],
          ['北京理工大学','九江学院','广东文理职业学院','广州现代信息工程职业技术学院'],
          ['华南理工大学','广州大学纺织服装学院','广东文艺职业学院','南宁职业技术学院']
        ],
        arr:[
          ['中央美术学院','江西师范大学','上海工艺美术职业学院','常州纺织服装职业技术学院'],
          ['清华大学美术学院','华侨大学','顺德职业技术学院','河南轻工职业学院'],
          ['同济大学','五邑大学','山东艺术设计职业学院','黑龙江三江美术职业学院'],
          ['广州美术学院','江西服装学院','广州番禺职业技术学院','无锡工艺职业技术学院'],
          ['湖北美术学院','广东海洋大学','天津工艺美术职业学院','广东工程职业技术学院'],
          ['四川美术学院','广东技术师范大学','广东职业技术学院','广东科学技术职业学院'],
          ['西安美术学院','上海师范大学天华学院','中山职业技术学院','威海职业学院'],
          ['中国美术学院上海设计学院','南通大学','广东岭南职业技术学院','云南轻纺职业学院'],
          ['北京理工大学','九江学院','广东文理职业学院','广州现代信息工程职业技术学院'],
          ['华南理工大学','广州大学纺织服装学院','广东文艺职业学院','南宁职业技术学院'],
          ['中国传媒大学','佛山科学技术学院','广东省外语艺术职业学院','湖南工艺美术职业学院'],
          ['北京工业大学','惠州学院','广州城市职业学院','青岛职业技术学院'],
          ['北京林业大学','黄冈师范学院','广州工程技术职业学院','常州信息职业技术学院'],
          ['中央民族大学','信阳师范学院','广州涉外经济职业技术学院','江西现代职业技术学院'],
          ['上海视觉艺术学院','福建工程学院','湖北工业职业技术学院','东莞职业技术学院'],
          ['华中师范大学','北京师范大学珠海分校','惠州城市职业学院','内蒙古商贸职业学院'],
          ['大连外国语大学','广州大学华软软件学院','惠州经济职业技术学院','南京工业职业技术学院'],
          ['广东工业大学','广东财经大学华商学院','上海济光职业技术学院','江西环境工程职业学院'],
          ['北京联合大学','广东科技学院','阳江职业技术学院','成都纺织高等专科学校'],
          ['湖北工业大学','广州航海学院','珠海城市职业技术学院','广州市番禺区新造职业技术学校'],
          ['华南农业大学','广州商学院','珠海艺术职业学院','河北工业职业技术学院'],
          ['武汉理工大学','广东轻工职业技术学院','安徽职业技术学院','青岛酒店管理职业技术学院'],
          ['江汉大学','深圳职业技术学院','北京财贸职业学院','中山市沙溪理工学校'],
          ['华南师范大学','苏州工艺美术职业技术学院','北京青年政治学院','']
        ],
        layerpageinfo: {
          pageSize: 10,
          pageNo: 0,
          total: 24
        },
      }
    },
    methods:{
      changePage(pageNo){
        this.layerpageinfo.pageNo = pageNo;
        let list = this.arr.slice((pageNo-1)*this.layerpageinfo.pageSize,((pageNo-1)*this.layerpageinfo.pageSize)+this.layerpageinfo.pageSize);
        this.list = list;
      }
    }
  }
</script>

<style lang="scss">
.settled_school{
    .banner{
      width: 100%;
      height: 350px;
      background-color: #999999;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .school{
      width: 100%;
      background-color: #fff;
      padding: 80px 0;
      .top{
        padding-bottom: 40px;
        h3{
          font-size: 30px;
          color: #111111;
          text-align: center;
        }
        ul{
          display: flex;
          justify-content: center;
          margin-top: 25px;
        }
        ul li{
          position: relative;
          margin-right: 30px;
          &:before{
            position: absolute;
            content: '';
            width: 6px;
            height: 6px;
            background-color: #C3C3C3;
            border-radius: 50%;
            top: 0;
            bottom: 0;
            margin: auto 0;
            left: -15px;
          }
        }
        ul li span{
          font-size: 26px;
          color: #FF733C;
        }
      }
      .school_list{
        width: 100%;
        border-top: 1px solid #EEEEEE;
        border-left: 1px solid #EEEEEE;
        li{
          display: flex;
        }
        li:nth-child(2n+0){
          background-color: #F5F5F5;
        }
        li .item{
          flex: 1;
          height: 61px;
          line-height: 61px;
          padding-left: 39px;
          border-bottom: 1px solid #EEEEEE;
          border-right: 1px solid #EEEEEE;
          font-size: 14px;
          color: #4B5062;
        }
      }
      .page_box{
        display: flex;
        justify-content: flex-end;
      }
    }
  .contact{
    background-color: #F5F5F5;
    .m{
      padding: 80px 0;
      h3{
        color: #111111;
        font-size: 30px;
        text-align: center;
      }
      ul{
        display: flex;
        margin-top: 39px;
      }
      ul li{
        background-color: #ffffff;
        width: 387px;
        height: 194px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: 1px solid #E7E9EC;
        margin-right: 20px;
        i{
          font-size: 30px;
          color: #4B5062;
        }
        span{
          color: #4B5062;
          margin-top: 32px;
        }
      }
      ul li:last-child{
        margin-right: 0;
      }
    }
  }
  .synopsis{
    background-color: #fff;
    .m{
      padding: 80px 0;
      h3{
        color: #111111;
        font-size: 30px;
        text-align: center;
      }
      ul{
        display: flex;
        margin-top: 80px;
        justify-content: space-around;
      }
      ul li{
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
          width: 38px;
          height: 44px;
          background-color: #999999;
        }
        div{
          margin-top: 40px;
          text-align: center;
        }
        div h4{
          font-size: 16px;
          color: #333333;
          margin-bottom: 12px;
        }
        div span{
          color: #999999;
          font-size: 14px;
        }
      }
    }
  }

  .icon{
    display: inline-block;
  }
  .icon-phone{
    background-image: url("~@/assets/img/settled_school/phone.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 30px;
    height: 30px;
  }
  .icon-email{
    background-image: url("~@/assets/img/settled_school/email.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 37px;
    height: 27px;
  }
  .icon1{
    background-image: url("~@/assets/img/settled_school/icon1.png");
    background-repeat: no-repeat;
    background-size: 100%;
    width: 38px;
    height: 44px;
  }
  .icon2{
    background-image: url("~@/assets/img/settled_school/icon2.png");
    background-repeat: no-repeat;
    background-size: 100%;
    width: 37px;
    height: 44px;
  }
  .icon3{
    background-image: url("~@/assets/img/settled_school/icon3.png");
    background-repeat: no-repeat;
    background-size: 100%;
    width: 45px;
    height: 44px;
  }
  .icon4{
    background-image: url("~@/assets/img/settled_school/icon4.png");
    background-repeat: no-repeat;
    background-size: 100%;
    width: 38px;
    height: 44px;
  }
  .icon5{
    background-image: url("~@/assets/img/settled_school/icon5.png");
    background-repeat: no-repeat;
    background-size: 100%;
    width: 37px;
    height: 44px;
  }
}
</style>
